export default function base_Url() {
    return process.env.VUE_APP_BASE_URL
}
